<div class="arp">
  <header class="arp-header">
    <div>
      <h1>AI Reports</h1>
      <p>Generate daily, BoQ, BoM and deviation reports from project records. Figures come from the database; AI writes the narrative.</p>
    </div>
  </header>

  <nav class="arp-tabs" role="tablist">
    <button
      type="button"
      role="tab"
      *ngFor="let t of types"
      [class.active]="t.type === activeType"
      [attr.aria-selected]="t.type === activeType"
      (click)="selectType(t.type)"
    >
      {{ t.label }}
    </button>
  </nav>

  <section class="arp-card">
    <p class="arp-desc">{{ activeMeta.description }}</p>
    <app-ai-report-form
      [type]="activeType"
      [preset]="preset"
      [busy]="generating"
      (submitted)="generate($event)"
      (projectChange)="onProjectChange($event)"
    ></app-ai-report-form>
  </section>

  <div class="arp-body">
    <aside class="arp-history">
      <div class="arp-history-head">
        <h3>History</h3>
        <span class="muted" *ngIf="!historyLoading">{{ history.length }}</span>
      </div>
      <p class="muted small" *ngIf="historyLoading">Loading…</p>
      <p class="muted small" *ngIf="!historyLoading && !history.length">
        No saved {{ activeMeta.label.toLowerCase() }}s{{ projectId ? ' for this project' : '' }} yet.
      </p>
      <ul>
        <li
          *ngFor="let h of history"
          [class.active]="report?.id === h.id"
          (click)="open(h.id)"
          tabindex="0"
          (keydown.enter)="open(h.id)"
        >
          <div class="h-top">
            <span class="h-title">{{ h.project_name || 'Project #' + h.project_id }}</span>
            <button type="button" class="h-del" title="Delete" (click)="remove(h, $event)">✕</button>
          </div>
          <span class="h-sub">{{ h.title }}</span>
          <span class="h-meta">
            <span class="dot" [class.on]="h.ai_used"></span>
            {{ h.ai_used ? 'AI' : 'Rule-based' }} · {{ h.created_at | date: 'short' }}
          </span>
        </li>
      </ul>
    </aside>

    <main class="arp-main">
      <div class="arp-card" *ngIf="report && !loadingReport">
        <app-ai-report-view [report]="report" [busy]="generating" (regenerate)="regenerate()"></app-ai-report-view>
      </div>
      <div class="arp-empty" *ngIf="loadingReport || generating && !report">
        {{ generating ? 'Collecting project data and writing the report…' : 'Loading report…' }}
      </div>
      <div class="arp-empty" *ngIf="!report && !loadingReport && !generating">
        Choose a project and generate a report, or open one from history.
      </div>
    </main>
  </div>
</div>
